import { useHits } from 'react-instantsearch-hooks-web';
import useDynamicFacets from '../../hooks/useDynamicFacets';
import { FacetConfiguration } from '../../types';


interface Props {
  facetsConfiguration: Record<string, FacetConfiguration>;
}

const DesktopFacets: React.FC<Props> = ({ facetsConfiguration }) => {

  const { results } = useHits();
  const facets = useDynamicFacets({
    configuration: facetsConfiguration,
    ordering: results?.renderingContent?.facetOrdering?.facets?.order,
    render: ({ attribute, Component }) => (     
        <span>{Component}</span>
    ),
  });

  return (
    <div className="2xl:pb-10 flex flex-col justify-center items-start md:items-center gap-12 lg:gap-24">
        {facets}
    </div>
  );
  }
export default DesktopFacets;